import * as React from "react";
import GenerateQRForm from './GenerateQRForm';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import WAChatWidget from './WAChatWidget';
import WAChatLink from './WAChatLink';
import AITokenCalculator from "./AITokenCalculator";
import CustomTabs from "../../common/custom-tabs"; // Adjust the import path as needed
import { ColorsConstants } from "../../cssUtils/constants";

const ContentContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  minHeight: '400px',
  backgroundColor: 'transparent', // Add this line to make background transparent
}));

const GenerateQR = (props) => {
  const [selectedOption, setSelectedOption] = React.useState("generateQR");

  const options = [
    { id: "generateQR", label: "WhatsApp QR Code Generator" },
    { id: "chatLinkGenerator", label: "WhatsApp Chat Link Generator" },
    { id: "chatBtnGenerator", label: "WhatsApp Chat Button Generator" },
    // { id: "aiTokensCalculator", label: "AI Tokens Calculator" },
  ];

  const handleOptionChange = (event, newValue) => {
    setSelectedOption(newValue);
  };

  const renderContent = () => {
    switch (selectedOption) {
      case "generateQR":
        return <GenerateQRForm refreshKey={props.refreshKey} />;
      case "chatLinkGenerator":
        return <WAChatLink refreshKey={props.refreshKey} />;
      case "chatBtnGenerator":
        return <WAChatWidget refreshKey={props.refreshKey} />;
      case "aiTokensCalculator":
        return <AITokenCalculator refreshKey={props.refreshKey} />;
      default:
        return <div>Select an option from the tabs above.</div>;
    }
  };

  return (
    <div className="App">
      <Container maxWidth={false} sx={{ bgcolor: '#FAFAFA' }}>
        <Grid container spacing={2}>
          {/* Full width content area */}
          <Grid item xs={12}>
            {/* Custom Tabs at the top - full width */}
            <Box sx={{ mb: 3, width: '100%', mt:3 }}>
              <CustomTabs
                value={selectedOption}
                onChange={handleOptionChange}
                tabs={options.map(opt => ({ label: opt.label, value: opt.id }))}
                activeBgColor={ColorsConstants.primaryBackgroundColor}
                inactiveBgColor="#F3F5F7"
                activeTextColor="#FFFFFF"
                inactiveTextColor="#6C7C93"
                sx={{
                  backgroundColor: "#F3F5F7",
                  width: "100%",
                }}
              />
            </Box>

            {/* Content area below tabs - full width stretched */}
            <ContentContainer sx={{p:0}}>
              {renderContent()}
            </ContentContainer>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default GenerateQR;